export default (req, res, next) => {
    if (process.env.ASSET_SIGNING_KEY_PAIR_ID && process.env.ASSET_SIGNING_PRIVATE_KEY) {
        const cookie = require("cookie");
        const cloudfront = require("@aws-sdk/cloudfront-signer");

        const policy = {
            Statement: [
                {
                    Resource: "http*://assets.deploy-preview.procreate.art/*", // http* = http and https
                    Condition: {
                        DateLessThan: {
                            "AWS:EpochTime": Math.floor(new Date().getTime() / 1000) + 60 * 60 * 1, // Current Time in UTC + time in seconds, (60 * 60 * 1 = 1 hour)
                        },
                    },
                },
            ],
        };

        const cookies = cloudfront.getSignedCookies({
            privateKey: process.env.ASSET_SIGNING_PRIVATE_KEY,
            keyPairId: process.env.ASSET_SIGNING_KEY_PAIR_ID,
            policy: JSON.stringify(policy),
        });

        const cookieOptions = {
            domain: ".deploy-preview.procreate.art",
            path: "/",
            httpOnly: true,
            secure: true,
        };

        res.setHeader("Set-Cookie", [
            cookie.serialize("CloudFront-Key-Pair-Id", cookies["CloudFront-Key-Pair-Id"], cookieOptions),
            cookie.serialize("CloudFront-Policy", cookies["CloudFront-Policy"], cookieOptions),
            cookie.serialize("CloudFront-Signature", cookies["CloudFront-Signature"], cookieOptions),
        ]);
    }

    next();
};
